export enum ContractorStatus {
  Active = 0,
  Inactive = 1,
  Suspended = 2,
  PendingVerification = 3,
  Rejected = 4,
}
